import { render, staticRenderFns } from "./QueuesTags.vue?vue&type=template&id=11fd5543&scoped=true"
import script from "./QueuesTags.vue?vue&type=script&lang=js"
export * from "./QueuesTags.vue?vue&type=script&lang=js"
import style0 from "./QueuesTags.vue?vue&type=style&index=0&id=11fd5543&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fd5543",
  null
  
)

export default component.exports